import _ from 'lodash/fp'
import { createActions, createTypes, createReducer } from './util'

export const namespace = 'clubs'

const typeKeys = [
  'CLUB_REQUEST',
  'CLUBS_REQUEST',
  'FINISH_REQUEST',
  'FINISH_REQUEST_MULTI',
  'SUCCESS_REQUEST'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

export const initialState = {
  items: {}
}

const reducer = {
  [types.CLUB_REQUEST]: () => _.set('waiting', true),
  [types.CLUBS_REQUEST]: () => _.set('waiting', true),
  [types.FINISH_REQUEST]: p => _.set('items.' + p.id, p),
  [types.FINISH_REQUEST_MULTI]: p => _.set('items', _.keyBy('id', p)),
  [types.SUCCESS_REQUEST]: () => _.set('waiting', false)
}

export default createReducer(initialState, reducer)

function createSelectors () {
  const ns = _.get(namespace)
  const clubs = _.flow(ns, _.get('items'))
  const activeClubs = _.flow(clubs, _.omitBy({ active: false }))
  const clubById = id => _.flow(clubs, _.get(id))
  return {
    clubs,
    activeClubs,
    clubById
  }
}

export const selectors = createSelectors()
